





















import Vue from 'vue';
import { includes } from 'lodash';

import Datepicker from '@/components/datepicker/Datepicker.vue';

export default Vue.extend({
  name: 'EditCardDate',
  components: {
    Datepicker,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    subtype: {
      type: String,
      required: true,
      validate: (subtype: string) => includes(['date', 'datetime'], subtype),
    },
    required: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  computed: {
    enableTime(): boolean {
      return this.subtype === 'datetime';
    },
  },
});
